<template>
  <!-- prettier-ignore -->
  <index-content>
    <template v-if="hasRW" #options>
      <div class="n-button-box">
        <nb-add @on-click="openModal" />
      </div>
    </template>
    <search-condition searchable :loading="searching" @do-search="search">
      <ns-company v-model="condition.companyId" all-option />
      <n-field-enum v-model="condition.configType" enum-name="AdminConfigType" label="configType" all-option />
      <n-field-selection v-model="condition.operatorId" selection-name="admin.operator" label="operator" all-option />
    </search-condition>
    <n-table :total="total" :page-no="pageNo" :page-size="pageSize" :searched="searched" :searching="searching" :has-result="hasResult" @on-page-no="onPageNo" @on-page-size="onPageSize">
      <table class="table table-striped table-bordered table-hover text-center n-table">
        <thead>
          <tr>
            <th class="col-weight-1">{{ $t('label.company') }}</th>
            <th class="col-weight-1">{{ $t('label.operator') }}</th>
            <th class="col-weight-1">{{ $t('label.configType') }}</th>
            <th class="col-weight-5">{{ $t('label.configValue') }}</th>
            <th class="n-table-timestamp">{{ $t('label.time') }}</th>
            <th v-table-action class="action-edit">{{ $t('label.action') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in records" :key="row.id">
            <td v-selection:[`company.company`]="row.companyId"></td>
            <td v-selection:[`admin.operator`]="row.operatorId">{{ row.operatorId }}</td>
            <td v-enums:AdminConfigType="row.configType"></td>
            <td class="n-ellipsis" :title="row.configValue">{{ row.configValue | hyphen }}</td>
            <td>{{ row.updateDatetime | datetime }}</td>
            <td class="n-button-box">
              <nb-modal @on-click="openModal(row)" />
            </td>
          </tr>
        </tbody>
      </table>
    </n-table>
  </index-content>
</template>

<script>
import OperatorView from './view';
import PaginateMixin from '@/mixins/paginate-mixin';
import ModalOperatorConfig from './ModalOperatorConfig';
import { fetch } from '@/api/operator/operator-operator-config';

export default OperatorView.extend({
  name: 'OperatorOperatorConfig',
  mixins: [PaginateMixin],
  data() {
    return {
      condition: {
        companyId: 0,
        configType: 0,
        operatorId: 0,
      },
    };
  },
  methods: {
    doSearch(params) {
      let p = { ...params, ...this.condition };
      return fetch(p);
    },
    parse(rows) {
      this.records = rows.records;
    },
    openModal(model = {}) {
      this.createModal(ModalOperatorConfig, { model, on: this });
    },
  },
});
</script>
